export const FILTER_TODAY = 'today';
export const FILTER_ONE_WEEK = '1w';
export const FILTER_FOUR_WEEKS = '4w';
export const FILTER_ONE_YEAR = '1y';
export const FILTER_WEEK_TIL_TODAY = 'wtd';
export const FILTER_MONTH_TIL_TODAY = 'mtd';
export const FILTER_QUARTER_TIL_TODAY = 'qtd';
export const FILTER_YEAR_TIL_TODAY = 'ytd';
export const FILTER_CUSTOM = 'custom';

export const AVAILABLE_FILTERS = [
  FILTER_TODAY,
  FILTER_ONE_WEEK,
  FILTER_ONE_YEAR,
  FILTER_WEEK_TIL_TODAY,
  FILTER_MONTH_TIL_TODAY,
  FILTER_QUARTER_TIL_TODAY,
  FILTER_YEAR_TIL_TODAY,
  FILTER_CUSTOM,
];

// Action types
export const SELECT_FILTER = 'rangeFilter/SELECT_FILTER';
export const SET_DATES = 'rangeFilter/SET_DATES';

export const SET_DIRTY = 'rangeFilter/SET_DIRTY';
export const RESET_DIRTY = 'rangeFilter/RESET_DIRTY';
